import {
  VpButton,
  VpModal,
  VpModalBody,
  VpModalCloseButton,
  VpModalDialog,
  VpModalFooter,
  VpModalHeader,
} from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  onClose: (continueCustomActions: boolean) => void
}

const CustomActionsRemainingModal = ({ open, onClose }: Props) => {
  const { t } = useTranslation('common')
  return (
    <VpModal
      data-testid="custom-actions-remaining-modal"
      open={open}
      onOpen={() => {}}
      onClose={() => onClose(true)}
    >
      <VpModalDialog aria-label="Custom Actions Remaining">
        <VpModalHeader>
          <h1>{t('pages.action-list.custom-actions-remaining-modal.title')}</h1>
          <VpModalCloseButton />
        </VpModalHeader>
        <VpModalBody className="px-8">
          {t('pages.action-list.custom-actions-remaining-modal.message')}
        </VpModalBody>
        <VpModalFooter className="flex-col">
          <VpButton
            data-testid="continue-custom-actions-button"
            className="w-full"
            shape="squared"
            onClick={() => onClose(true)}
          >
            {t('pages.action-list.custom-actions-remaining-modal.continue-button')}
          </VpButton>
          <VpButton
            data-testid="quit-later-button"
            className="w-full"
            variant="secondary"
            shape="squared"
            onClick={() => onClose(false)}
          >
            {t('pages.action-list.custom-actions-remaining-modal.quit-button')}
          </VpButton>
        </VpModalFooter>
      </VpModalDialog>
    </VpModal>
  )
}

export default CustomActionsRemainingModal
